<!-- 单据上传 -->
 <template> 
 <div>
    <div class="flex_box">
        <el-form :inline="true" :model="formSeacher" class="demo-form-inline" size="mini"  label-width="100px">
            <el-row :gutter="1">
                <el-col :span="5">
                    <el-form-item label="报关单类型">
                        <el-select  placeholder="请选择报关单类型" :default-first-option="true" v-model="formSeacher.type">
                            <el-option v-for="item in queryDeclarationTypeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeName">
                                <span class="margin_right_20">{{ item.codeValue }}</span>
                                <span >{{ item.codeName }}</span> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="报关单号">
                        <el-input v-model="formSeacher.entryNo" clearable placeholder="请输入报关单号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="合同协议号">
                        <el-input v-model="formSeacher.contrNo" clearable placeholder="请输入合同协议号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="9">
                    <el-form-item label="放行日期">
                        <el-date-picker v-model="declareDeta" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions" @change="getData" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="1">
                <el-col :span="5">
                    <el-form-item label="进出口标志">
                        <el-select clearable  placeholder="请选择进出口标志" :default-first-option="true" v-model="formSeacher.ieFlag">
                            <el-option v-for="item in importsExportsCodeList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName" :value="item.codeValue">
                                <span class="margin_right_20">{{ item.codeValue }}</span>
                                <span >{{ item.codeName }}</span> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="提单号">
                        <el-input v-model="formSeacher.billNo" clearable placeholder="请输入提单号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="境内收发货人">
                        <el-select clearable filterable remote :remote-method="getEnterpriseList" :default-first-option="true" placeholder="请选择境内收发货人" 
                        v-model="formSeacher.ownerName">
                            <el-option v-for="item in enterpriseList" :key="item.id" :label="item.companyName" :value="item.companyName">
                                <span>{{ item.companyName }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item  label="主管海关">
                        <el-select clearable filterable remote :remote-method="getCustomsList" :default-first-option="true" v-model="formSeacher.customMaster"
                        placeholder="请选择主管海关">
                            <el-option v-for="item in customsList"  :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName " :value="item.codeValue">
                                <span class="margin_right_20">{{ item.codeValue }}</span>
                                <span >{{ item.codeName }}</span> 
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item>
                        <el-button type="success" size="mini" plain @click="onSubmit">查询</el-button>
                        <el-button size="mini" type="primary"  plain @click="batchDialog=true" icon="el-icon-upload">资料上传</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div style="flex: 1;">
            <el-table  :data="tableList" :header-cell-style="{'text-align':'center'}" height="100%" >
                <el-table-column label="序号" type="index" width="80" align="center"> </el-table-column>
                <el-table-column label="境内收发货人" prop="ownerName" align="center"> </el-table-column>
                <el-table-column label="合同协议号" prop="contrNo" align="center"> </el-table-column>
                <el-table-column label="提单号" prop="billNo" align="center"> </el-table-column>
                <el-table-column label="报关单类型" prop="type" align="center"> </el-table-column>
                <el-table-column label="运输工具名称" prop="trafName" align="center"> </el-table-column>
                <el-table-column label="航次号" prop="voyNo" align="center"> </el-table-column>
                <el-table-column label="报关单号" prop="entryNo" align="center"> </el-table-column>
                <el-table-column label="放行日期" prop="entryDate" align="center"> </el-table-column>
                <el-table-column label=""  align="center"> 
                    <template slot-scope="scope">
                        <el-button  @click="upload(scope.row)" type="primary" plain size="mini">随附单据</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        
    </div>
    <!-- 上传随附单证 -->
    <uploadDocuments :uploadShow="uploadShow" :id="id" @uploadClose="uploadClose" :isDeclareUpload="true"></uploadDocuments>
    <!-- 批量上传弹窗 -->
    <el-dialog title="批量上传资料" :visible.sync="batchDialog" @close="closeBatchDialog">
        <el-form>
            <el-form-item label="资料类型">
                <el-radio v-model="batchFileForm.fileType" label="报关单">报关单</el-radio>
                <el-radio v-model="batchFileForm.fileType" label="报关资料">报关资料</el-radio>
            </el-form-item>
            <el-form-item label="匹配规则">
                <el-radio-group v-model="batchFileForm.rule" :disabled="batchFileForm.fileType === '报关资料' ? true : false" size="mini">
                    <el-radio label="报关单号">报关单号</el-radio>
                    <el-radio label="统一编号">统一编号</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
         <el-upload class="upload-demo" :action="batchFileURL" multiple :file-list="batchFiles" :auto-upload="false"
         :on-change="changeBatchFile" :on-remove="removeBatchFile">
            <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>
            <el-button size="mini" type="success" @click="batchUpload" style="margin-left: 10px;">上传文件</el-button>
        </el-upload>
    </el-dialog>
 </div>
    
 </template>
 <script>
import AEObasicData from '@/config/AEObasicData.js'
import uploadDocuments from '@/components/AEO/uploadDocuments.vue'
 
 export default {
    name: 'declareUpload',
    components:{
        uploadDocuments
    },
    data() {
        return {
            declareDeta:[],
            formSeacher:{
                type:'一般报关单', // 报关单类型
                entryNo:'', //报关单号
                billNo:'', //提单号
                startDate:'', //放行日期
                endDate:'', //放行日期
                ieFlag:'', // 进出口标志
                contrNo:'', //  合同协议号
            },
            tableList:[],
            uploadShow:false,
            enterpriseList:[], // 企业列表
            customsList:[], //海关列表
            id:'', // 查询随附单证id
            queryDeclarationTypeList:AEObasicData.queryDeclarationTypeList,
            importsExportsCodeList:AEObasicData.importsExportsCodeList, // 进出口标志
            minLimitDate:'',
            // 批量上传弹窗
            batchFileURL:'',
            batchDialog:false,
            batchFileForm:{
                fileType:'', // 资料类型
                rule:'', // 匹配规则
            },
            batchFiles:[],
            pickerOptions: {
                shortcuts: [{
                    text: '当天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        picker.$emit('pick', [start, end]);
                    }
                },{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }],
                onPick: ({ maxDate, minDate }) => {
                    // 当用户选择第一个日期时，设置第二个日期的可选范围
                    if (minDate && !maxDate) {
                        this.minDate = minDate;
                        this.maxDate = new Date(minDate);
                        this.maxDate.setDate(minDate.getDate() + 30);
                        
                        this.minLimitDate = new Date(minDate);
                        this.minLimitDate.setDate(minDate.getDate() - 30);
                    }
                },
                disabledDate: (time) => {
                    // 如果没有选择第一个日期，不禁用任何日期
                    if (!this.minDate) return false;
                    
                    // 限制只能选择第一个日期前后30天内的日期
                    return (
                        time.getTime() < this.minLimitDate.getTime() ||
                        time.getTime() > this.maxDate.getTime()
                    );
                }
            },
        }
    },
    watch: {
        'batchFileForm.fileType'(val) { 
            if(val === '报关资料'){
                this.batchFileForm.rule = '报关资料'
            }else{
                this.batchFileForm.rule = ''
            }
        },  
    },
    mounted() { 
        // this.onSubmit()
    },
    methods: {
        getData(value){
            if(value){
                this.formSeacher.startDate = value[0]
                this.formSeacher.endDate = value[1]
            }else{
                this.formSeacher.startDate = ''
                this.formSeacher.endDate = ''
            }
        },
        // 获取企业列表
        getEnterpriseList(value){
            this.$api.getCompanyList(  {companyName:value } ).then(res =>{
                this.enterpriseList = res.tableData
            })
        },
        // 海关信息
        getCustomsList(value){
            if(value && value !== ' '){
                this.customsList = AEObasicData.CUS_CUSTOMS.filter(item =>
                    item.codeName.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeValue.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        onSubmit(){
            if( this.formSeacher.billNo === '' && this.formSeacher.entryNo === '' && this.formSeacher.contrNo === ''){
                if( this.formSeacher.startDate == '' || this.formSeacher.endDate == ''){
                    this.$message.error('请选择放行日期！')
                    return false
                }
            }
            this.$api.getDeclaredBills( this.formSeacher  ).then(res =>{
                this.tableList = res
            })
        },
        upload(data){
            this.id = data.id
            this.uploadShow = true
        },
        // 关闭上传单证弹窗
        uploadClose(){
            this.id = ''
            this.uploadShow = false
        },
        // 选择文件
        changeBatchFile(file, fileList){
            this.batchFiles = fileList
        },
        // 移除文件
        removeBatchFile(file, fileList){
            this.batchFiles = fileList
        },  
        // 批量上传
        batchUpload(){
            if(this.batchFiles.length === 0){
                this.$message.error('请选择文件')
                return false
            }
            if(this.batchFileForm.fileType === ''){
                this.$message.error('请选择资料类型')
                return false
            }else{
                if(this.batchFileForm.fileType === '报关单'){
                    if(this.batchFileForm.rule === ''){
                        this.$message.error('请选择匹配规则')
                        return false
                    }
                    // 报关单只能上传pdf
                    const isAllPDF = this.batchFiles.every(item => item.raw.type === 'application/pdf');
                    if (!isAllPDF) {
                        this.$message.error('请上传PDF格式的文件');
                        return false;
                    }
                }
            }
            const formData = new FormData();
            this.batchFiles.forEach(item => {
                formData.append('files', item.raw);
            });
            this.$api.upLoadDeclFiles(this.batchFileForm.fileType, this.batchFileForm.rule,formData).then(res =>{
                this.closeBatchDialog()
                this.$alert(res.replace(/[\n\r]+/g, '<br>'), '提示', {
                    dangerouslyUseHTMLString: true
                });
                // this.$alert(res, '提示', {
                //     confirmButtonText: '确定',
                //     callback: action => {
                //     }
                // });
            })

        },
        // 关闭批量上传弹窗
        closeBatchDialog(){
            this.batchDialog = false
            this.batchFileForm.fileType = ''
            this.batchFileForm.rule = ''
            this.batchFiles = []
        }
    }
 }
 </script>
 <style lang="css" scoped>
.el-table {
    margin-top: -1px;
}
.flex_box{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 85px);
}
.margin_right_20{
    margin-right: 20px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 2px;
}
 </style>